import { FilterOperator } from 'common/filter/filterConstants'

export const isFilterOperator = (value: unknown): value is FilterOperator => {
  return Object.values(FilterOperator).includes(value as FilterOperator)
}
